import './Label.scss';

const Label = props => (
  <label htmlFor={props.for || ''}>{props.children}</label>
);

export default Label;
